import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { IconButton, type IconButtonProps } from '@atlaskit/button/new';
import LinkIcon from '@atlaskit/icon/core/link';

import { generateAudioShareLink } from '../../../common/audioSharingUtils';
import { useAudioPlayerStore } from '../../hooks/useAudioPlayerStore';

const messages = defineMessages({
	link: {
		id: 'audio.audio-player.audio-share-link-button.link',
		defaultMessage: 'Link to audio',
		description: 'Label and tooltip for the audio share link button',
	},
});

export const AudioShareLinkButton = () => {
	const { formatMessage } = useIntl();
	const { activeContent, activeFeature } = useAudioPlayerStore();

	const handleCopyLink = () => {
		const link = generateAudioShareLink(
			activeContent.mainContentLink,
			activeFeature,
			activeContent.supportingContent,
		);
		navigator.clipboard.writeText(link);
	};

	const tooltipOptions: IconButtonProps['tooltip'] = {
		content: formatMessage(messages.link),
		position: 'bottom',
		hideTooltipOnClick: true,
	};

	return (
		<IconButton
			icon={LinkIcon}
			label={formatMessage(messages.link)}
			tooltip={tooltipOptions}
			onClick={handleCopyLink}
			isTooltipDisabled={false}
			isDisabled={activeContent.mainContentLink === ""}
			shape='circle'
		/>
	);
};
